"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var plugin_1 = require("./plugin");
var directive_1 = require("./directive");
var view_tracking_1 = require("./view-tracking");
var GTMVue = /** @class */ (function () {
    function GTMVue() {
    }
    GTMVue.install = function (Vue, options) {
        var id = options.id, disableDirective = options.disableDirective, directiveName = options.directiveName, router = options.router, ignoredViews = options.ignoredViews, debug = options.debug, enabled = options.enabled;
        utils_1.appendScript(id, debug);
        Vue.gtm = Vue.prototype.$gtm = new plugin_1.AnalyticsPlugin(enabled, debug);
        if (!disableDirective) {
            directive_1.setupDirective(Vue, directiveName || 'track');
        }
        if (router) {
            view_tracking_1.setupViewTracking(Vue, router, ignoredViews);
        }
    };
    return GTMVue;
}());
exports.default = GTMVue;
//# sourceMappingURL=index.js.map